var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlFilledEighteen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 37,
    viewBox: "0 0 40 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.253 27.8381C35.899 27.4637 37.1283 25.9935 37.131 24.2348C37.1279 22.1927 35.4717 20.5382 33.4289 20.5382C31.3861 20.5382 29.7299 22.1927 29.7267 24.2348C29.7294 25.9927 30.9575 27.4623 32.6023 27.8376C30.3934 28.1268 28.5447 29.5585 27.6683 31.5206C26.7637 28.7058 24.28 26.5993 21.2601 26.2437C23.3138 25.8239 24.8592 24.0086 24.8625 21.8316C24.8588 19.3438 22.841 17.3281 20.3523 17.3281C17.8636 17.3281 15.8458 19.3438 15.842 21.8316C15.8453 24.0086 17.3907 25.8239 19.4444 26.2437C16.4248 26.5992 13.9414 28.7053 13.0365 31.5196C12.1599 29.5579 10.3109 28.1268 8.1023 27.8376C9.74712 27.4623 10.9752 25.9927 10.9779 24.2348C10.9748 22.1927 9.31859 20.5382 7.27574 20.5382C5.23298 20.5382 3.57673 22.1927 3.5736 24.2348C3.57632 25.9935 4.80559 27.4637 6.45156 27.8381C3.35806 28.2421 0.96875 30.8859 0.96875 34.0896V36.9069H39.7357V34.0896C39.7358 30.8859 37.3465 28.2421 34.253 27.8381Z",
    fill: "#2D5E59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8787 10.5263L20.3484 9.39071L23.8181 10.5263L23.7946 6.9226L25.9624 4.02064L22.4783 2.9291L20.3484 0L18.2186 2.9291L14.7344 4.02064L16.9022 6.9226L16.8787 10.5263Z",
    fill: "#2D5E59"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.47426 14.0332L3.85968 13.2761L6.24503 14.0332L6.22889 11.6307L7.7193 9.69612L5.32391 8.96836L3.85968 7.01562L2.39539 8.96836L0 9.69612L1.49041 11.6307L1.47426 14.0332Z",
    fill: "#2D5E59"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3168 14.0332L36.4853 13.2761L38.6539 14.0332L38.6392 11.6307L39.9941 9.69612L37.8165 8.96836L36.4853 7.01562L35.1542 8.96836L32.9766 9.69612L34.3314 11.6307L34.3168 14.0332Z",
    fill: "#2D5E59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlFilledEighteen);
export default __webpack_public_path__ + "static/media/al-filled-eighteen.15b1655b1d468cb6d472fe8ef88ea719.svg";
export { ForwardRef as ReactComponent };